import React from 'react';
import "./AllIndustries.css";
import { Link as RouterLink } from 'react-router-dom';
import CustomLink from '../CustomLink/CustomLink';

const Link = ({ to, children, ...rest }) => {
  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <RouterLink to={to} onClick={handleClick} {...rest}>
      {children}
    </RouterLink>
  );
};

const IndustriesGrid = ({ Items, page }) => {
  return (
    <div className="industriesGrid-GridContainer">
      {Items.map((industry) => (
        <Link to={`/${page}/${industry.id}`} key={industry.id} className="industriesGrid-GridItem">
          <div className="industriesGrid-ContentSvg">
            <div className='industriesGrid-SvgInline'>
              <h1 className="industriesGrid-GridTitlemainSvg">{industry.title}</h1>
              <img
                className="industriesGrid-GridIcon"
                src={industry.icon}
                alt={industry.title}
              />
            </div>
            <p className="industriesGrid-GridDescriptionMain">{industry.description}</p>
          </div>
        </Link>
      ))}
    </div>
  );
};

const AllIndustries = ({ products, title, details, link, linktext }) => {
  // Transform products to match the expected structure for IndustriesGrid
  const transformedIndustries = products.map((product) => ({
    id: product._id?.$oid || product._id || '',
    title: product.title || '', // Use title directly
    description: product.shortdescription || product.details || '', // Prefer shortdescription, fallback to details
    icon: product.icon || (product.photo && product.photo[0]?.url) || '', // Use icon or the first photo as fallback
  }));

  return (
    <div className='AllIndustries-MainContainer'>
      <div className='AllIndustries-DetailsContainer'>
      <div className='AllIndustries-CapTitleStyle'>{title}</div>
      <div className='AllIndustries-CapDescriptionStyle'>{details}</div>
      <CustomLink link={link} linktext={linktext}/>
      </div>
      <div className='AllIndustries-industriesGrid'>
        <IndustriesGrid Items={transformedIndustries} page={link} />
      </div>
    </div>
  );
}

export default AllIndustries;
